var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon button"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 12781",
    d: "M11.86 3L11.56 3.3C10.86 4.012 10.091 5.632 10.587 6.456L7.552 8.531L7.5 8.478C7.22536 8.2002 6.89834 7.97965 6.53786 7.82913C6.17739 7.67861 5.79064 7.6011 5.4 7.6011C5.00936 7.6011 4.62261 7.67861 4.26214 7.82913C3.90166 7.97965 3.57464 8.2002 3.3 8.478L3 8.778L6.77 12.588L3.32 16.088L3.92 16.694L7.37 13.194L11.14 17.001L11.44 16.701C11.9965 16.1355 12.3085 15.3739 12.3085 14.5805C12.3085 13.7871 11.9965 13.0255 11.44 12.46L11.388 12.407L13.439 9.342C14.255 9.842 15.997 9.209 16.701 8.497L17.001 8.197L11.86 3ZM11.109 15.758L4.23 8.811C4.63759 8.53962 5.12687 8.41846 5.614 8.46826C6.10113 8.51807 6.55577 8.73575 6.9 9.084L10.84 13.063C11.1851 13.4144 11.3999 13.8731 11.4488 14.3632C11.4977 14.8532 11.3778 15.3453 11.109 15.758ZM10.776 11.786L8.163 9.148L11.147 7.112L12.792 8.778L10.776 11.786ZM13.64 8.417L11.499 6.256C11.108 5.861 11.685 4.742 11.911 4.264L15.748 8.139C15.275 8.367 14.03 8.812 13.639 8.417H13.64Z",
    fill: "#455079",
    stroke: "#455079",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.c145260f0ea7987b63e3b302df70db62.svg";
export { ForwardRef as ReactComponent };